import {useMutation, useQuery, useQueryClient} from 'react-query';
import SpaceSettingApiService from '../services/SpaceSettingApiService';
import {message} from 'antd';
import {useTranslation} from 'react-i18next';

const useCurrentSpace = () => {
  const {t} = useTranslation('setting');
  const queryClient = useQueryClient();

  const {data, ...rest} = useQuery('spaces', async () => {
    const {data} = await SpaceSettingApiService.getCurrentSpace();
    return data;
  });

  const {mutateAsync: updateSetting} = useMutation(SpaceSettingApiService.updateSetting,
    {
      onSuccess: () => {
        queryClient.invalidateQueries('spaces').then();
        queryClient.invalidateQueries('spacesetting').then();
        message.success(t('spaceSaved')).then();
      }
    });

  return {
    data,
    ...rest,
    updateSetting
  };
};

export default useCurrentSpace;
